import React from "react";
import { CustomTitle } from "../../../components";
import { Flex } from "antd";

// Assest
import logo1 from "../../../assets/images/gc-logo.png";
import logo2 from "../../../assets/images/eclipse-logo.png";
import logo3 from "../../../assets/images/virtual-logo.png";

const Leaders = () => {
  return (
    <div className="leaders">
      <div className="container">
        <CustomTitle
          text="Backed by leaders in healthcare and logistics"
          fontSize="16px"
          fontWeight="600"
          color="black"
          textAlign="center"
          marginBottom="24px"
        />
        <div className="leader-logos">
          <img src={logo1} alt="" />
          <img src={logo2} alt="" />
          <img src={logo3} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Leaders;
